import declare from "dojo/_base/declare";
import reflection from "csi/reflection";
import Widget from "csi/table/Widget";
import { stringSubstitute } from "csi/utility/stringUtility";
import { ViewWidget } from "csi/view/Widget";

const ProductHierarchyLevelTable = declare(Widget, {
	/**
	 * @override
	 * resolve view path
	 */
	_resolveView() {
		this._resolveViewPath(this);
		this.inherited(arguments);
	},

	/**
	 * Substitute correct relationship in path to access ProductHierarchy
	 */
	_resolveViewPath(view: ViewWidget): void {
		view.relRoot.m_addPaths?.forEach((path) => {
			path.m_path = stringSubstitute(path.m_path, [this._resolveViewRelation(view)]);
		});
	},

	/**
	 * Return appropriate relationship to ProductHierarchy
	 */
	_resolveViewRelation(view: ViewWidget): string {
		const node = view.getViewNode();

		if (!node) {
			return "_X_";
		}

		// Subtype may not be correct when using request generator, so just return dummy string; otherwise stringSubstitute hangs
		return node.$Type == "ProductHierarchy" ? "ProductHierarchy" : (reflection.getSubtypeName(node.Subtype) || "_X_");
	},
});

export = ProductHierarchyLevelTable;